module.exports = __webpack_public_path__ + "media/Rema-Beamer-Bad-Boys-ft.-Rvssian.6cf45a17.mp3";